import { FC } from 'react'
import { motion } from 'framer-motion'

import { Word } from 'models'
import { Highlight, SortingOptions } from './styled'

export const SORTING_OPTIONS = [
  {
    label: ' өстәлү тәртибендә',
    key: 'default',
  },
  {
    label: 'әлифба тәртибендә',
    key: 'tatar',
    sortFunc: (a: Word, b: Word) => a.tatar.localeCompare(b.tatar),
  },
  {
    label: 'alphabetically',
    key: 'en',
    sortFunc: (a: Word, b: Word) => a.english.localeCompare(b.english),
  },
  {
    label: 'по алфавиту',
    key: 'ru',
    sortFunc: (a: Word, b: Word) => a.russian.localeCompare(b.russian),
  },
]

export type Sort = {
  key: string
  ord: 'asc' | 'desc'
}

type Props = {
  sorting: Sort
  onChange: React.Dispatch<React.SetStateAction<Sort>>
}

export const Sorting: FC<Props> = ({ sorting, onChange }) => (
  <SortingOptions>
    {SORTING_OPTIONS.map(filter => (
      <button
        key={filter.key}
        disabled={sorting.key === filter.key}
        data-type={filter.key}
        onClick={() =>
          onChange(v => ({
            key: filter.key,
            ord:
              v.key === filter.key
                ? ({ asc: 'desc', desc: 'asc' }[v.ord] as 'asc' | 'desc')
                : 'asc',
          }))
        }
      >
        {filter.label}{' '}
        {sorting.key === filter.key &&
          sorting.ord === 'desc' &&
          `(${sorting.ord})`}
        {sorting.key === filter.key && (
          <Highlight style={{ borderRadius: 1000 }} layoutId="highlight" />
        )}
      </button>
    ))}
  </SortingOptions>
)
